<div fxLayout="row" class="flexwrap">

  <div fxFlex="100%" fxFlex.lt-md="100%">
    {{ 'procedure.title' | translate }}
  </div>

  <mat-form-field class="campoFormulario">
    <mat-label>{{ 'procedure.dialog.name.label' | translate }}</mat-label>
    <input matInput [(ngModel)]="data.procedure.name" name="name" required [disabled]="data.isEdit">
    <mat-error>
      {{ 'procedureEdit.dialog.name.error' | translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="campoFormulario">
    <mat-label>{{ 'procedure.dialog.description.label' | translate }}</mat-label>
    <input matInput [(ngModel)]="data.procedure.description" name="description" required>
    <mat-error>
      {{ 'procedureEdit.dialog.description.error' | translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="campoFormulario">
    <mat-label> {{ 'procedure.filter.app.label' | translate }} </mat-label>
    <mat-select [(ngModel)]="data.procedure.idApps" name="idsApp" required multiple
      [ngModelOptions]="{standalone: true}">
      @for (item of appTypes; track item) {
        <mat-option [value]="item.id">
          {{ item.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div fxFlex="100%" fxFlex.lt-md="100%" style="margin-top: 1.5em">

    <div fxFlex="5px"></div>

    <button mat-raised-button color="primary"
    (click)="save()">{{ 'button.save' | translate }}</button>

    <div fxFlex="5px"></div>

    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</div>